import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { actionScripts } from "../../_helpers/actionScripts";
import "./styles/adrAmendments.css";
import AdrAmendmentAnnotationsV3 from "./AdrAmendmentAnnotationsV3";

class AdrAmendmentHistoryV3 extends Component {
  handleClick_amend = (amendAdrId) => (e) => {
    e.preventDefault();
    const { adr } = this.props;
    if (!adr) return;
    actionScripts.FETCH_ADR.run(adr.projectId, amendAdrId);
  };

  render() {
    const { adr, amendmentHistory } = this.props;
    return (
      <div className="card bg-lightgray my-1">
        <div className="card-body p-2">
          <div className="d-flex flex-row w-100 mb-0 amend-history-row">
            <div className="flex-shrink-0">
              <label htmlFor="amendLinks" className="col-form-label mr-2">
                <b>Amendments:</b>
              </label>
            </div>
            <div className="flex-grow-1">
              <div className="d-flex flex-row flex-wrap">
                {adr &&
                  (amendmentHistory || []).map((adrHist, index) => {
                    const adrId = adrHist.assistantDailyReportId;
                    return (
                      <div key={`amendLinkKey_${index}`} className="amend-history-item">
                        <button
                          type="button"
                          name={`amendLink_${index}`}
                          id={`amendLink_${index}`}
                          className="btn btn-secondary mr-2 py-1"
                          onClick={this.handleClick_amend(adrId)}
                          disabled={adrId === adr.assistantDailyReportId}
                        >
                          <span>
                            <b>{index === 0 ? "Original" : `#${adrHist.amendmentNo}`}</b>
                            {adrId === adr.assistantDailyReportId && (
                              <span className="ml-1">
                                (Current
                                <FontAwesomeIcon
                                  icon="hand-point-down"
                                  className="fa-fw ml-1"
                                />
                                )
                              </span>
                            )}
                            {!adrHist.isApproved && (
                              <span className="ml-1">{adrHist.status}</span>
                            )}
                          </span>
                        </button>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {adr && adr.isAmendment && adr.amendmentAnnotation && (
            <AdrAmendmentAnnotationsV3 annotation={adr.amendmentAnnotation} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  amendmentHistory:
    state.adr.miscSessionData.amendmentHistory[ownProps.originalAdrId] || null,
  adr: state.adr.openAdrs[ownProps.tabId] || null,
});

export default connect(mapStateToProps)(AdrAmendmentHistoryV3);
